import $ from 'jquery';

$(function () {
  var AccountsTable = function () {
    this.section = $('section.accounts');
    this.form = this.section.find('#employee_search');
    this.nameSearchInput = this.form.find('.js-search-input');
    this.managerSearchInput = this.form.find('.js-manager-filter');
    this.deactivatedCheckbox = this.form.find('.js-show-deactivated');
    this.nameSearchTimeout = null;
  };

  AccountsTable.prototype.init = function () {
    this.bindNameSearch();
    this.bindManagerSearch();
    this.bindDeactivatedCheckbox();
    this.bindLoadingIndicator();
  };

  AccountsTable.prototype.bindNameSearch = function () {
    var self = this;

    self.nameSearchInput.on('input', function () {
      clearTimeout(self.nameSearchTimeout);

      self.nameSearchTimeout = setTimeout(function () {
        self.form.submit();
      }, 500);
    });
  };

  AccountsTable.prototype.bindManagerSearch = function () {
    var self = this;

    self.section.on('typeahead:select', function (ev, suggestion) {
      clearTimeout(self.nameSearchTimeout);

      var managerId = self.managerSearchInput
        .find('option')
        .filter(function () {
          return $(this).text().trim() == suggestion;
        })
        .attr('value');

      self.managerSearchInput.val(managerId);
      self.form.submit();
    });

    $('.js-manager-input').on('keypress', function (e) {
      if (e.which == 13 && !this.value) {
        self.managerSearchInput.val('');
        self.form.submit();
      }
    });
  };

  AccountsTable.prototype.bindDeactivatedCheckbox = function () {
    var self = this;

    self.deactivatedCheckbox.on('input', function () {
      clearTimeout(self.nameSearchTimeout);
      self.form.submit();
    });
  };

  AccountsTable.prototype.bindLoadingIndicator = function () {
    var self = this;

    self.section
      .bind('ajax:beforeSend', function () {
        self.section
          .find('.tab-pane.active')
          .empty()
          .append('<div class="loading-indicator">');
      })
      .bind('ajax:complete', function () {
        self.section.find('.loading-indicator').remove();
      });
  };

  if ($('body.accounts.index').length >= 1) {
    new AccountsTable().init();
  }
});
